export default __webpack_public_path__ + "static/Absorbent_Substrate-e4413077f558f86f7d7103408a043f23.png";